<script>
  import Modal from "@/core/components/Modal"
  import Loader from "@/core/components/Loader"
  import { hourFormat } from "@/core/services/helpers"

  export default {
    components: {
      Modal,
      Loader,
    },
    props: {
      title: { type: String, default: "" },
      idLinha: { type: Number, default: null },
    },
    data() {
      return {
        showSchedule: false,
        line: {
          line: "",
          name: "",
          itinerary: "",
          schedules: [],
        },
        diasDaSemana: [
          { id: 1, dia: "Segunda" },
          { id: 2, dia: "Terça" },
          { id: 3, dia: "Quarta" },
          { id: 4, dia: "Quinta" },
          { id: 5, dia: "Sexta" },
          { id: 6, dia: "Sábado" },
          { id: 0, dia: "Domingo" },
        ],
      }
    },
    watch: {
      closed: function () {
        this.page = 1
      },
    },
    mounted() {
      if (this.idLinha) {
        this.findSchedule()
      }
    },
    methods: {
      formatHour(time) {
        return hourFormat(time)
      },
      async findSchedule() {
        try {
          const response = await this.$axios.get(
            "/api/lines/route/" + parseInt(this.idLinha)
          )
          this.line.nulinharamal =
            response.data.nulinharamal + "-" + response.data.nuextensao
          this.line.origin = response.data.origin_point.nmlocalidade
          this.line.destiny = response.data.destiny_point.nmlocalidade
          this.line.transportadora =
            response.data.deter_registry.organization.business_name
          this.line.name = response.data.deitinerario
          this.line.schedules = response.data["line_schedules"]
          this.showSchedule = true
        } catch (e) {
          this.status = "rejected"
          this.$Progress.finish()
        }
      },
    },
  }
</script>

<template>
  <div>
    <Modal width="800" :no-padding="true" :no-margin="true">
      <div
        v-if="!showSchedule"
        slot="header"
        class="flex items-center justify-content-center m-3"
      >
        <loader wrapperClass="text-green-base" loaderClass="w-60 h-60"/>
      </div>
      <div v-if="showSchedule" slot="header">
        <div
          class="font-bold uppercase text-gray-700 flex items-center justify-content-center p-2"
        >
          {{
                        line.nulinharamal +
                        " | " +
                        line.origin +
                        " - " +
                        line.destiny
                    }}
        </div>
      </div>
      <div slot="body" class="p-0">
        <div v-if="showSchedule">
          <div class="p-5">
            <div class="align-baseline mb-1">
              <h3 class="text-gray-700 uppercase pt-5 font-bold">
                Transportadora: {{ line.transportadora }}
              </h3>
              <h3 class="text-gray-700 uppercase pt-5 font-bold">
                Itinerário: {{ line.name }}
              </h3>
              <h3 class="text-gray-700 uppercase pt-5 font-bold">
                Horários de Partida
              </h3>
            </div>
          </div>
          <div class="grid grid-cols-7 gap-0">
            <div
              v-for="diaDaSemana in diasDaSemana"
              :key="diaDaSemana.id"
              class=""
            >
              <div
                class="flex justify-center items-center p-2 h-16 font-bold text-gray-700 border"
              >
                {{ diaDaSemana.dia }}
              </div>
              <div class="w-full flex flex-wrap justify-content-center">
                <div v-for="(schedule, index) in line.schedules" :key="index">
                  <div
                    v-if="
                                            schedule.tpdirecao == 1 &&
                                            schedule.nudiasemana ==
                                                diaDaSemana.id
                                        "
                    class="flex items-center justify-content-center mr-2"
                  >
                    <div class="timer-clock-lines">
                      {{ formatHour(schedule.hrpartida) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-5">
            <div>
              <h3 class="text-gray-700 uppercase pt-5 font-bold">
                Horários de Volta
              </h3>
            </div>
          </div>
          <div class="grid grid-cols-7 gap-0">
            <div
              v-for="diaDaSemana in diasDaSemana"
              :key="diaDaSemana.id"
              class=""
            >
              <div
                class="flex justify-center items-center p-2 h-16 font-bold text-gray-700 border"
              >
                {{ diaDaSemana.dia }}
              </div>
              <div class="w-full flex flex-wrap justify-content-center">
                <div v-for="(schedule, index) in line.schedules" :key="index">
                  <div
                    v-if="
                                            schedule.tpdirecao == 2 &&
                                            schedule.nudiasemana ==
                                                diaDaSemana.id
                                        "
                    class="flex items-center justify-content-center mr-2"
                  >
                    <div class="timer-clock-lines">
                      {{ formatHour(schedule.hrpartida) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="flex justify-center items-end h-full w-full p-2">
          <button
            class="px-2 py-2 mb-2 form-submit sm:py-1 font-bold w-auto"
            style="z-index: 999"
            @click="$emit('close')"
          >
            <div class="flex items-center justify-center">Fechar Lista</div>
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>
